module.exports = __webpack_public_path__ + "static/media/brand_fortalezatec_escuro.7766b21c.png";